var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"showTopDismissButton":true,"showFooter":false},on:{"dismiss":_vm.dismiss}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"modal-content pt10 pb10"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }